module.exports = __webpack_public_path__ + "static/excluding3-b8cbcad07f760a2795e0e11e290dac71.png";